import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { PageShell } from "../components/PageShell";
import { submitContact } from "../lib/api";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";

export default function Contact() {
  const [searchParams] = useSearchParams();
  const about = searchParams.get("about");
  const [form, setForm] = useState({
    name: "", email: "",
    message: about ? `Data correction for ${about.toUpperCase()}: ` : "",
  });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await submitContact(form);
      toast.success(res.message);
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <PageShell eyebrow="Get in touch" title="Contact">
      <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-neutral-600">
        Questions about the data, a figure you'd like us to double-check, privacy requests, press,
        or partnership ideas — send a message and we'll get back to you.
      </p>

      {sent ? (
        <div data-testid="contact-success" className="mt-10 rounded-lg border border-[#1D9E7540] bg-[#1D9E7508] px-6 py-10 text-center">
          <h2 className="font-heading text-2xl font-semibold text-[#157a59]">Message received</h2>
          <p className="mt-2 text-neutral-600">Thanks for reaching out — we'll reply to {form.email} as soon as we can.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 max-w-xl space-y-5">
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-neutral-500">Your name</label>
            <Input data-testid="contact-name" required value={form.name} onChange={set("name")} placeholder="Your name" />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-neutral-500">Email</label>
            <Input data-testid="contact-email" required type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-neutral-500">Message</label>
            <Textarea data-testid="contact-message" required rows={6} value={form.message} onChange={set("message")}
              placeholder="How can we help?" className="resize-y" />
          </div>
          <button
            data-testid="contact-submit"
            type="submit"
            disabled={busy}
            className="rounded-full bg-[#1a1a18] px-6 py-3 text-sm font-medium text-white transition-transform active:scale-95 hover:opacity-90 disabled:opacity-50"
          >
            {busy ? "Sending…" : "Send message"}
          </button>
        </form>
      )}
    </PageShell>
  );
}
